// Full ISO 3166-1 alpha-2 country list with French names
export const COUNTRIES = [
  {code:'AF',name:'Afghanistan',ar:'أفغانستان'},{code:'ZA',name:'Afrique du Sud',ar:'جنوب أفريقيا'},
  {code:'AL',name:'Albanie',ar:'ألبانيا'},{code:'DZ',name:'Algérie',ar:'الجزائر'},
  {code:'DE',name:'Allemagne',ar:'ألمانيا'},{code:'AD',name:'Andorre',ar:'أندورا'},
  {code:'AO',name:'Angola',ar:'أنغولا'},{code:'SA',name:'Arabie Saoudite',ar:'المملكة العربية السعودية'},
  {code:'AR',name:'Argentine',ar:'الأرجنتين'},{code:'AM',name:'Arménie',ar:'أرمينيا'},
  {code:'AU',name:'Australie',ar:'أستراليا'},{code:'AT',name:'Autriche',ar:'النمسا'},
  {code:'AZ',name:'Azerbaïdjan',ar:'أذربيجان'},{code:'BH',name:'Bahreïn',ar:'البحرين'},
  {code:'BD',name:'Bangladesh',ar:'بنغلاديش'},{code:'BE',name:'Belgique',ar:'بلجيكا'},
  {code:'BJ',name:'Bénin',ar:'بنين'},{code:'BY',name:'Biélorussie',ar:'بيلاروسيا'},
  {code:'BO',name:'Bolivie',ar:'بوليفيا'},{code:'BA',name:'Bosnie-Herzégovine',ar:'البوسنة والهرسك'},
  {code:'BW',name:'Botswana',ar:'بوتسوانا'},{code:'BR',name:'Brésil',ar:'البرازيل'},
  {code:'BN',name:'Brunei',ar:'بروناي'},{code:'BG',name:'Bulgarie',ar:'بلغاريا'},
  {code:'BF',name:'Burkina Faso',ar:'بوركينا فاسو'},{code:'BI',name:'Burundi',ar:'بوروندي'},
  {code:'KH',name:'Cambodge',ar:'كمبوديا'},{code:'CM',name:'Cameroun',ar:'الكاميرون'},
  {code:'CA',name:'Canada',ar:'كندا'},{code:'CV',name:'Cap-Vert',ar:'الرأس الأخضر'},
  {code:'CF',name:'Centrafrique',ar:'أفريقيا الوسطى'},{code:'CL',name:'Chili',ar:'تشيلي'},
  {code:'CN',name:'Chine',ar:'الصين'},{code:'CY',name:'Chypre',ar:'قبرص'},
  {code:'CO',name:'Colombie',ar:'كولومبيا'},{code:'KM',name:'Comores',ar:'جزر القمر'},
  {code:'CG',name:'Congo',ar:'الكونغو'},{code:'CD',name:'Congo (RDC)',ar:'الكونغو الديمقراطية'},
  {code:'KR',name:'Corée du Sud',ar:'كوريا الجنوبية'},{code:'KP',name:'Corée du Nord',ar:'كوريا الشمالية'},
  {code:'CR',name:'Costa Rica',ar:'كوستاريكا'},{code:'CI',name:"Côte d'Ivoire",ar:'ساحل العاج'},
  {code:'HR',name:'Croatie',ar:'كرواتيا'},{code:'CU',name:'Cuba',ar:'كوبا'},
  {code:'DK',name:'Danemark',ar:'الدنمارك'},{code:'DJ',name:'Djibouti',ar:'جيبوتي'},
  {code:'EG',name:'Égypte',ar:'مصر'},{code:'AE',name:'Émirats Arabes Unis',ar:'الإمارات العربية المتحدة'},
  {code:'EC',name:'Équateur',ar:'الإكوادور'},{code:'ER',name:'Érythrée',ar:'إريتريا'},
  {code:'ES',name:'Espagne',ar:'إسبانيا'},{code:'EE',name:'Estonie',ar:'إستونيا'},
  {code:'SZ',name:'Eswatini',ar:'إسواتيني'},{code:'US',name:'États-Unis',ar:'الولايات المتحدة'},
  {code:'ET',name:'Éthiopie',ar:'إثيوبيا'},{code:'FI',name:'Finlande',ar:'فنلندا'},
  {code:'FR',name:'France',ar:'فرنسا'},{code:'GA',name:'Gabon',ar:'الغابون'},
  {code:'GM',name:'Gambie',ar:'غامبيا'},{code:'GE',name:'Géorgie',ar:'جورجيا'},
  {code:'GH',name:'Ghana',ar:'غانا'},{code:'GR',name:'Grèce',ar:'اليونان'},
  {code:'GT',name:'Guatemala',ar:'غواتيمالا'},{code:'GN',name:'Guinée',ar:'غينيا'},
  {code:'GQ',name:'Guinée équatoriale',ar:'غينيا الاستوائية'},{code:'GW',name:'Guinée-Bissau',ar:'غينيا بيساو'},
  {code:'GY',name:'Guyana',ar:'غيانا'},{code:'HT',name:'Haïti',ar:'هايتي'},
  {code:'HN',name:'Honduras',ar:'هندوراس'},{code:'HK',name:'Hong Kong',ar:'هونغ كونغ'},
  {code:'HU',name:'Hongrie',ar:'المجر'},{code:'IN',name:'Inde',ar:'الهند'},
  {code:'ID',name:'Indonésie',ar:'إندونيسيا'},{code:'IQ',name:'Irak',ar:'العراق'},
  {code:'IR',name:'Iran',ar:'إيران'},{code:'IE',name:'Irlande',ar:'أيرلندا'},
  {code:'IS',name:'Islande',ar:'آيسلندا'},{code:'IL',name:'Israël',ar:'إسرائيل'},
  {code:'IT',name:'Italie',ar:'إيطاليا'},{code:'JM',name:'Jamaïque',ar:'جامايكا'},
  {code:'JP',name:'Japon',ar:'اليابان'},{code:'JO',name:'Jordanie',ar:'الأردن'},
  {code:'KZ',name:'Kazakhstan',ar:'كازاخستان'},{code:'KE',name:'Kenya',ar:'كينيا'},
  {code:'KG',name:'Kirghizistan',ar:'قيرغيزستان'},{code:'KW',name:'Koweït',ar:'الكويت'},
  {code:'LA',name:'Laos',ar:'لاوس'},{code:'LV',name:'Lettonie',ar:'لاتفيا'},
  {code:'LB',name:'Liban',ar:'لبنان'},{code:'LR',name:'Liberia',ar:'ليبيريا'},
  {code:'LY',name:'Libye',ar:'ليبيا'},{code:'LI',name:'Liechtenstein',ar:'ليختنشتاين'},
  {code:'LT',name:'Lituanie',ar:'ليتوانيا'},{code:'LU',name:'Luxembourg',ar:'لوكسمبورغ'},
  {code:'MK',name:'Macédoine du Nord',ar:'مقدونيا الشمالية'},{code:'MG',name:'Madagascar',ar:'مدغشقر'},
  {code:'MY',name:'Malaisie',ar:'ماليزيا'},{code:'MW',name:'Malawi',ar:'ملاوي'},
  {code:'MV',name:'Maldives',ar:'المالديف'},{code:'ML',name:'Mali',ar:'مالي'},
  {code:'MT',name:'Malte',ar:'مالطا'},{code:'MA',name:'Maroc',ar:'المغرب'},
  {code:'MU',name:'Maurice',ar:'موريشيوس'},{code:'MR',name:'Mauritanie',ar:'موريتانيا'},
  {code:'MX',name:'Mexique',ar:'المكسيك'},{code:'MD',name:'Moldavie',ar:'مولدوفا'},
  {code:'MC',name:'Monaco',ar:'موناكو'},{code:'MN',name:'Mongolie',ar:'منغوليا'},
  {code:'ME',name:'Monténégro',ar:'الجبل الأسود'},{code:'MZ',name:'Mozambique',ar:'موزمبيق'},
  {code:'MM',name:'Myanmar',ar:'ميانمار'},{code:'NA',name:'Namibie',ar:'ناميبيا'},
  {code:'NP',name:'Népal',ar:'نيبال'},{code:'NI',name:'Nicaragua',ar:'نيكاراغوا'},
  {code:'NE',name:'Niger',ar:'النيجر'},{code:'NG',name:'Nigeria',ar:'نيجيريا'},
  {code:'NO',name:'Norvège',ar:'النرويج'},{code:'NZ',name:'Nouvelle-Zélande',ar:'نيوزيلندا'},
  {code:'OM',name:'Oman',ar:'عُمان'},{code:'UG',name:'Ouganda',ar:'أوغندا'},
  {code:'UZ',name:'Ouzbékistan',ar:'أوزبكستان'},{code:'PK',name:'Pakistan',ar:'باكستان'},
  {code:'PS',name:'Palestine',ar:'فلسطين'},{code:'PA',name:'Panama',ar:'بنما'},
  {code:'PG',name:'Papouasie-Nouvelle-Guinée',ar:'بابوا غينيا الجديدة'},
  {code:'PY',name:'Paraguay',ar:'باراغواي'},{code:'NL',name:'Pays-Bas',ar:'هولندا'},
  {code:'PE',name:'Pérou',ar:'بيرو'},{code:'PH',name:'Philippines',ar:'الفلبين'},
  {code:'PL',name:'Pologne',ar:'بولندا'},{code:'PT',name:'Portugal',ar:'البرتغال'},
  {code:'QA',name:'Qatar',ar:'قطر'},{code:'RO',name:'Roumanie',ar:'رومانيا'},
  {code:'GB',name:'Royaume-Uni',ar:'المملكة المتحدة'},{code:'RU',name:'Russie',ar:'روسيا'},
  {code:'RW',name:'Rwanda',ar:'رواندا'},{code:'SN',name:'Sénégal',ar:'السنغال'},
  {code:'RS',name:'Serbie',ar:'صربيا'},{code:'SL',name:'Sierra Leone',ar:'سيراليون'},
  {code:'SG',name:'Singapour',ar:'سنغافورة'},{code:'SK',name:'Slovaquie',ar:'سلوفاكيا'},
  {code:'SI',name:'Slovénie',ar:'سلوفينيا'},{code:'SO',name:'Somalie',ar:'الصومال'},
  {code:'SD',name:'Soudan',ar:'السودان'},{code:'SS',name:'Soudan du Sud',ar:'جنوب السودان'},
  {code:'LK',name:'Sri Lanka',ar:'سريلانكا'},{code:'SE',name:'Suède',ar:'السويد'},
  {code:'CH',name:'Suisse',ar:'سويسرا'},{code:'SR',name:'Suriname',ar:'سورينام'},
  {code:'SY',name:'Syrie',ar:'سوريا'},{code:'TJ',name:'Tadjikistan',ar:'طاجيكستان'},
  {code:'TW',name:'Taïwan',ar:'تايوان'},{code:'TZ',name:'Tanzanie',ar:'تنزانيا'},
  {code:'TD',name:'Tchad',ar:'تشاد'},{code:'CZ',name:'Tchéquie',ar:'التشيك'},
  {code:'TH',name:'Thaïlande',ar:'تايلاند'},{code:'TL',name:'Timor oriental',ar:'تيمور الشرقية'},
  {code:'TG',name:'Togo',ar:'توغو'},{code:'TN',name:'Tunisie',ar:'تونس'},
  {code:'TM',name:'Turkménistan',ar:'تركمانستان'},{code:'TR',name:'Turquie',ar:'تركيا'},
  {code:'UA',name:'Ukraine',ar:'أوكرانيا'},{code:'UY',name:'Uruguay',ar:'أوروغواي'},
  {code:'VE',name:'Venezuela',ar:'فنزويلا'},{code:'VN',name:'Vietnam',ar:'فيتنام'},
  {code:'YE',name:'Yémen',ar:'اليمن'},{code:'ZM',name:'Zambie',ar:'زامبيا'},
  {code:'ZW',name:'Zimbabwe',ar:'زيمبابوي'},
];

export const PAYS_UE = [
  'DE','AT','BE','BG','CY','HR','DK','ES','EE','FI','FR','GR','HU','IE','IT',
  'LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','SE','CZ'
];

export const PAYS_GZALE = [
  'SA','BH','EG','AE','IQ','JO','KW','LB','LY','MA','MR','OM','PS','QA','SD','SY','TN','YE'
];

export const BANQUES_AGREEES = [
  'BNA — Banque Nationale d\'Algérie',
  'BEA — Banque Extérieure d\'Algérie',
  'CPA — Crédit Populaire d\'Algérie',
  'BADR — Banque de l\'Agriculture et du Développement Rural',
  'BDL — Banque de Développement Local',
  'CNEP — Caisse Nationale d\'Épargne et de Prévoyance',
  'Société Générale Algérie',
  'BNP Paribas El Djazaïr',
  'Arab Bank Algeria',
  'Natixis Algérie',
  'Gulf Bank Algeria',
  'ABC — Al Baraka Bank Algeria',
  'TRUST Bank Algeria',
  'AGB — Algerian Gulf Bank',
  'Fransabank',
  'Banque Al Salam',
  'HSBC Algeria',
];

export const INCOTERMS = [
  { code: 'EXW', label: 'EXW — Ex Works' },
  { code: 'FCA', label: 'FCA — Free Carrier' },
  { code: 'CPT', label: 'CPT — Carriage Paid To' },
  { code: 'CIP', label: 'CIP — Carriage & Insurance Paid' },
  { code: 'DAP', label: 'DAP — Delivered at Place' },
  { code: 'DPU', label: 'DPU — Delivered at Place Unloaded' },
  { code: 'DDP', label: 'DDP — Delivered Duty Paid' },
  { code: 'FAS', label: 'FAS — Free Alongside Ship' },
  { code: 'FOB', label: 'FOB — Free on Board' },
  { code: 'CFR', label: 'CFR — Cost & Freight' },
  { code: 'CIF', label: 'CIF — Cost, Insurance & Freight' },
];
